
import React from 'react';
import { DragOverlay } from '@dnd-kit/core';
import { ScrollArea } from '@/components/ui/scroll-area';
import { FulfillmentColumn as FulfillmentColumnType, Fulfillment } from '@/types/fulfillment';
import FulfillmentColumn from './FulfillmentColumn';
import FulfillmentCard from './FulfillmentCard';

interface FulfillmentBoardContentProps {
  columns: FulfillmentColumnType[];
  activeProject: Fulfillment | null;
  onProjectClick: (project: Fulfillment) => void;
}

const FulfillmentBoardContent = ({ 
  columns, 
  activeProject, 
  onProjectClick 
}: FulfillmentBoardContentProps) => {
  return (
    <>
      <ScrollArea orientation="horizontal" className="pb-6">
        <div className="flex gap-6 min-w-max">
          {columns.map((column) => (
            <FulfillmentColumn
              key={column.id}
              column={column}
              onProjectClick={onProjectClick}
            />
          ))}
        </div>
      </ScrollArea>

      <DragOverlay>
        {activeProject ? (
          <FulfillmentCard
            project={activeProject}
            onClick={() => {}}
          />
        ) : null}
      </DragOverlay>
    </>
  );
};

export default FulfillmentBoardContent;
